import React, { FC } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ],
    multi_sub_button: ['close - button1', 'close - button2', 'close - button3']
  }
};

const ModalSlideTracking: FC<any> = () => {
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let tracking = useSelector((state: RootState) => state.trackings.tracking);

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .modal_wrapper {
      width: 100%;
      padding: 1rem 0;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      overflow: hidden;
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
    }

    .close_btn {
      position: absolute;
      right: 0;
      top: 6%;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_wrapper .slick_image_wrapper {
      max-width: 12rem;
      width: 12rem;
      min-width: 12rem;
      max-height: 12rem;
      height: 12rem;
      min-height: 12rem;
      outline: 0;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
      outline: 0;
    }

    .slick_wrapper .slick-list {
      padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      padding: 0 0.5rem;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .contents_wrapper {
      width: 100%;
      height: 8rem;
      padding: 0 1rem;
    }
    .contents_box {
      height: 8rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;
      margin-bottom: 0.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4.5rem;

      display: flex;
      align-items: center;
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }

    .bar_blank {
      width: 100%;
      height: 0.25rem;
    }
    .btn_wrapper {
      width: 100%;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;
      background: transparent;
    }

    .tracking_center {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="close_btn tracking_center">
          <EditTracking
            value={tracking?.multi_sub_button?.[currentIndex]}
            type="multi_sub_button"
          />
        </div>
        <div className="modal_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper"></div>
          <div className="bar_blank" />
          <div className="btn_wrapper">
            <button className="tracking_center">
              <EditTracking
                value={tracking?.multi_button?.[currentIndex]}
                type="multi_button"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalSlideTracking;
